import Spinner from "./components/elements/Spinner";
import ErrorImage from "./components/elements/ErrorImage";
import Logo from "./components/elements/Logo";
import Breadcrumb from "./components/elements/Breadcrumb";

export default {
    spinner: Spinner,
    logo: Logo,
    "error-image": ErrorImage,
    breadcrumb: Breadcrumb
};
